export default "__VITE_ASSET__34a5526d__"